import { logWrapper } from '../../utils';
import toastr from 'toastr';
import swal from 'sweetalert2';

export default {
  digitalizationLinkController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$filter',
    '$state',
    'digitalizationService',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $filter,
      $state,
      digitalizationService
    ) {
      'use strict';
      $scope.model = {};
      $scope.folders = [];
      $scope.documentTypes = [];
      $scope.classifications = [];
      $scope.lista = [];
      $scope.isEdit = false;
      $scope.itemEditando = null;

      function showNotification(level, msg) {
        toastr.options = {
          closeButton: true,
          positionClass: 'toast-top-right',
          timeOut: '4000',
        };

        toastr[level]($filter('translate')(msg));
      }

      function loadFolders() {
        digitalizationService.getFolders()
          .then((res) => {
            var data = res.Folders || res;

            $scope.folders = data
              .filter(f => f.IdParent !== null && f.IdParent !== undefined)
              .map(f => ({
                id: f.Id,
                nome: f.Name
              }));
          })
          .catch(() => {
            showNotification('error', 'Erro ao carregar pastas');
          });
      }

      function loadDocumentTypes() {
        digitalizationService.getDocumentTypes()
          .then((res) => {
            var data = res.DocumentTypes || res;

            $scope.documentTypes = data.map(d => ({
              Id: d.Id,
              Name: d.Name
            }));
          })
          .catch(() => {
            showNotification('error', 'Erro ao carregar tipos');
          });
      }

      function loadClassifications() {
        digitalizationService.getClassifications()
          .then((res) => {
            $scope.classifications = res.map(c => ({
              id: c.Id,
              description: c.Description
            }));
          })
          .catch(() => {
            showNotification('error', 'Erro ao carregar classificações');
          });
      }

      function loadMetadatas() {
        digitalizationService.getMetadatas()
          .then((res) => {
            var data = res.Metadatas || res;

            $scope.lista = data.map(item => ({
              idFolder: item.IdFolder,
              idDocumentType: item.IdDocumentType,
              idDigitalizationClassification: item.IdDigitalizationClassification,

              folderNome: item.Folder?.Name,
              documentTypeNome: item.DocumentType?.Name,
              classificationNome: item.DigitalizationClassification?.Description
            }));
          })
          .catch(() => {
            showNotification('error', 'Erro ao carregar vínculos');
          });
      }

      function editar(item) {
        $scope.selectedItem = item;

        $scope.model = {
          classificationId: item.idDigitalizationClassification,
          classificationNome: item.classificationNome,
          folderId: item.idFolder,
          documentTypeId: item.idDocumentType
        };

        $scope.isEdit = true;
      }

      function cancelarEdicao() {
        $scope.model = {};
        $scope.isEdit = false;
        $scope.selectedItem = null;
      }

      function salvar() {
        if (
          !$scope.model.folderId ||
          !$scope.model.documentTypeId ||
          !$scope.model.classificationId
        ) {
          showNotification('warning', 'Preencha todos os campos');
          return;
        }

        var payload = {
          IdFolder: $scope.model.folderId,
          IdDocumentType: $scope.model.documentTypeId,
          IdDigitalizationClassification: $scope.model.classificationId
        };

        digitalizationService.updateMetadata(payload)
          .then(() => {
            loadMetadatas();
            $scope.cancelarEdicao();
            showNotification('success', 'Atualizado com sucesso');
          })
          .catch(() => {
            showNotification('error', 'Erro ao atualizar');
          });
      }

      function remover(item) {
        if (!item || !item.idDigitalizationClassification) {
          showNotification('error', 'Registro inválido');
          return;
        }

        swal.fire({
          title: $filter('translate')('CONFIRMAR REMOÇÃO'),
          text: $filter('translate')('Deseja realmente remover este vínculo?'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: $filter('translate')('REMOVER'),
          cancelButtonText: $filter('translate')('CANCELAR'),
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6'
        }).then((result) => {

          if (result.isConfirmed) {

            digitalizationService
              .deleteMetadata(item.idDigitalizationClassification)
              .then(() => {

                var index = $scope.lista.indexOf(item);
                if (index > -1) {
                  $scope.lista.splice(index, 1);
                }

                showNotification('success', 'Removido com sucesso');
              })
              .catch(() => {
                showNotification('error', 'Erro ao remover');
              });
          }
        });
      }

      function run() {
        try {
          $scope.title = $state.current.data.title;
          $scope.$parent.title = $scope.title;

          loadFolders();
          loadDocumentTypes();
          loadClassifications();
          loadMetadatas();

          $scope.salvar = logWrapper(
              salvar,
              runtimeConstant.isDebugControllersInternals
          );
          $scope.remover = logWrapper(
              remover,
              runtimeConstant.isDebugControllersInternals
          );
          $scope.editar = logWrapper(
              editar,
              runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelarEdicao = logWrapper(
              cancelarEdicao,
              runtimeConstant.isDebugControllersInternals
          );
          $rootScope.showNotification = logWrapper(
              showNotification,
              runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
        }
      }

      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};